import { gql } from '@apollo/client';

export const FETCH_LOCALES = gql`
    query fetchLocales {
        lookup {
            locales {
                id
                name
            }
        }
    }
`;
